import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import { GridColumn } from '../../../common/components/Grid/GridDataTypes';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { GetGroupedRecommendationsDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import mathUtils from '../../../utils/mathUtils';
import { RecommendedPublisherScopeObj } from '../../../common/pokCore/validation/enums';

interface RecommendedPublisherSearchProps {
  data: GetGroupedRecommendationsDto[];
  onRowClick: (key: string) => Promise<void> | void;
  refresh?: boolean;
}

export const RecommendedPublisherSearch: React.FC<
  RecommendedPublisherSearchProps
> = props => {
  const { t, tk } = useTranslation('administrationLng');

  const columns: GridColumn[] = [
    {
      header: t(tk.administration.profile),
      property: 'recommendedPublisher.profile',
    },
    {
      header: t(tk.recommendedPublisher.scope),
      property: 'recommendedPublisher.scopeType',
    },
    {
      header: t(tk.common.description),
      property: 'recommendedPublisher.description',
    },
    {
      header: t(tk.recommendedPublisher.publisherCount),
      property: 'recommendedPublisher.count',
    },
  ];

  const data = props.data.map(rec => {
    return {
      key: rec.id,
      values: {
        'recommendedPublisher.profile': rec.profileName,
        'recommendedPublisher.scopeType': t(
          RecommendedPublisherScopeObj[rec.scopeType],
        ),
        'recommendedPublisher.description': rec.description,
        'recommendedPublisher.count': rec.count,
      },
      orderByNumberValues: {
        'recommendedPublisher.count': mathUtils.parse(rec.count),
      },
      tdCssClass: {
        'recommendedPublisher.count': 'amounts-align-right',
      },
    };
  });

  return (
    <Grid
      data={data}
      columns={columns}
      showFilter={true}
      initialOrderColumn="recommendedPublisher.profileName"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.recommendedPublisher.noRecommendedPublishers)}
      onRowClick={props.onRowClick}
      refresh={props.refresh}
      withHistory={true}
      withFilterInColumns={true}
      showExport={true}
    />
  );
};
